import {Injectable} from '@angular/core';
import {RestApi} from 'app/auth/rest.api';
import { Observable } from 'rxjs';
import { IUserJob } from '../core/IUserJob';

@Injectable()
export class UserJobsService {

  private _getEndPoint = 'api/Scheduler/UserJobs';
  private _updateEndpoint = 'api/Scheduler/UserJob';
  private _getEndPointStatus = 'api/Scheduler/StatusReset';
  private _resetStatus = 'api/Scheduler/Reset';

  constructor(private _restApi: RestApi) { }

  public getAll(): Promise<IUserJob[]> {
    return this._restApi.get(this._getEndPoint).toPromise();
  }

  public update(userJob: IUserJob):  Observable<any> {
    return this._restApi.put(`${this._updateEndpoint}/${userJob.guid}`, userJob);
  }

  public getStatusReset(customJobId: string): Observable<any> {
    return this._restApi.get(`${this._getEndPointStatus}/${customJobId}`);
  }

  public resetStatus(customJobId: string): Observable<any> {
    return this._restApi.post(`${this._resetStatus}/${customJobId}`, customJobId);
  }
}
